import { markRaw } from "vue";
import { ethers } from "ethers";

const ABI = [
  "function getTokenInfo(address token) external view returns (uint256 version, address tokenManager, address quote, uint256 lastPrice, uint256 tradingFeeRate, uint256 minTradingFee, uint256 launchTime, uint256 offers, uint256 maxOffers, uint256 funds, uint256 maxFunds, bool liquidityAdded)",
  "function tryBuy(address token, uint256 amount, uint256 funds) public view returns (address tokenManager, address quote, uint256 estimatedAmount, uint256 estimatedCost, uint256 estimatedFee, uint256 amountMsgValue, uint256 amountApproval, uint256 amountFunds)",
  "function buyTokenAMAP(address token, uint256 funds, uint256 minAmount)",
  "function sellToken(address token, uint256 amount)",
];

const fourMeme = {
  namespaced: true,
  state: {
    fourMemePool: null,
    tokenManagerContract: "",
    tokenManagerAddress: "",
    liquidityAdded: false,
  },
  mutations: {
    setFourMemePool(state, payload) {
      state.fourMemePool = payload;
    },
    setTokenManagerContract(state, payload) {
      state.tokenManagerContract = payload;
    },
    setTokenManagerAddress(state, payload) {
      state.tokenManagerAddress = payload;
    },
    setLiquidityAdded(state, payload) {
      state.liquidityAdded = payload;
    },
  },
  getters: {},
  actions: {
    init({ rootState, commit }) {
      const fourMemePool = markRaw(
        new ethers.Contract(
          rootState.network.chain.fourMeme.poolAddress,
          ABI,
          rootState.ethereum.provider
        )
      );
      commit("setFourMemePool", fourMemePool);
    },
    async getTokenInfo({ state, rootState, commit }) {
      const tokenInfo = await state.fourMemePool.getTokenInfo(
        rootState.ethereum.tokenAddress
      );
      commit("setTokenManagerAddress", tokenInfo.tokenManager);
      commit("setLiquidityAdded", tokenInfo.liquidityAdded);
      const tokenManagerContract = markRaw(
        new ethers.Contract(
          tokenInfo.tokenManager,
          ABI,
          rootState.ethereum.provider
        )
      );
      commit("setTokenManagerContract", tokenManagerContract);
    },
    async tryBuy({ state, rootState }) {
      const tryBuy = await state.fourMemePool.tryBuy(
        rootState.ethereum.tokenAddress,
        0,
        ethers.utils.parseUnits("1", "ether")
      );
      const estimatedAmount = tryBuy.estimatedAmount.mul(1145).div(1000);
      return Math.trunc(
        ethers.utils
          .formatUnits(estimatedAmount, rootState.ethereum.metadata.decimals)
          .toString()
      );
    },
    async buy({ state, rootState, rootGetters, dispatch }, payload) {
      let { wallet, amount } = payload;
      amount = ethers.utils.parseEther(amount.toString());
      const signer = rootGetters["ethereum/getSinger"](wallet);
      const tryBuy = await state.fourMemePool.tryBuy(
        rootState.ethereum.tokenAddress,
        0,
        amount
      );
      const estimatedAmount = tryBuy.estimatedAmount;
      const amountOutMin = estimatedAmount.sub(
        estimatedAmount.mul(rootState.ethereum.slippage).div(100)
      );
      const tx = {
        to: state.tokenManagerAddress,
        value: amount,
        data: state.tokenManagerContract.interface.encodeFunctionData(
          "buyTokenAMAP",
          [rootState.ethereum.tokenAddress, amount, amountOutMin]
        ),
      };
      const gasLimit = Math.max(
        rootState.ethereum.gasLimit,
        await dispatch(
          "ethereum/estimateGas",
          { tx, provider: signer },
          { root: true }
        )
      );
      const gasPrice = await rootGetters[
        "ethereum/calculateGasPriceWithIncrement"
      ](rootState.ethereum.gasPrice);
      const gasCost = gasPrice.mul(gasLimit);
      const balance = await signer.getBalance();
      if (balance.sub(gasCost).lte(0)) {
        throw new Error("Insufficient balance to cover the gas cost.");
      }
      tx.gasLimit = gasLimit;
      tx.gasPrice = gasPrice;
      tx.nonce = await rootState.ethereum.provider.getTransactionCount(
        signer.address,
        "latest"
      );
      return await signer.sendTransaction(tx);
    },
    async sell({ state, rootState, rootGetters, dispatch }, payload) {
      let { wallet, amount } = payload;
      amount = ethers.utils.parseUnits(
        amount.toString(),
        rootState.ethereum.metadata.decimals
      );
      if (amount.lt(0)) {
        throw new Error("Token balance must be greater than or equal to 0");
      }
      const signer = rootGetters["ethereum/getSinger"](wallet);
      const tx = {
        to: state.tokenManagerAddress,
        data: state.tokenManagerContract.interface.encodeFunctionData(
          "sellToken",
          [rootState.ethereum.tokenAddress, amount]
        ),
      };
      const gasLimit = Math.max(
        rootState.ethereum.gasLimit,
        await dispatch(
          "ethereum/estimateGas",
          { tx, provider: signer },
          { root: true }
        )
      );
      const gasPrice = await rootGetters[
        "ethereum/calculateGasPriceWithIncrement"
      ](rootState.ethereum.gasPrice);
      const gasCost = gasPrice.mul(gasLimit);
      const balance = await signer.getBalance();
      if (balance.sub(gasCost).lte(0)) {
        throw new Error("Insufficient balance to cover the gas cost.");
      }
      tx.gasLimit = gasLimit;
      tx.gasPrice = gasPrice;
      tx.nonce = await rootState.ethereum.provider.getTransactionCount(
        signer.address,
        "latest"
      );
      return await signer.sendTransaction(tx);
    },
  },
};

export default fourMeme;
